import { A, DIV, H2, H3, P, SPAN } from 'sdi/components/elements';

const content = () =>
    DIV(
        '',
        P('', `OSMOA, un outil de suivi de donnés OpenStreetMap.`),
        P(
            '',
            `OSMOA est un outil de suivi et contrôle qualité de donnés thématiques d'OpenStreetMap. Grâce à des requêtes personnalisées, il permet de suivre les modifications apportées sur certains objets des données OpenStreetMap. L'outil est actuellement en phase de test au travers de cette démo.`
        ),
        H3('', 'Un suivi de données personnalisé'),
        P(
            '',
            `OSMOA permet de suivre certaines données d'OpenStreetMap d'un thème bien précis et dans une région donnée au travers de `,
            SPAN(
                { style: { fontWeight: 'bold' } },
                'requêtes personnalisées. '
            ),
            `Par exemple, cette instance analyse les évolutions des infrastructures cyclables en Wallonie au travers d'une série de requêtes.`
        ),
        H3('', 'Un suivi des objects OpenStreetMap'),
        P(
            '',
            `Il existe de nombreux outils de suivi et/ou de contrôle qualité des données OpenStreetMap, tels que Osmose, keepright, osmcha. OSMOA est un outil qui se focalise sur les `,
            SPAN({ style: { fontWeight: 'bold' } }, 'objets '),
            `plutôt que sur les ensembles de modifications (changeset OSM) et sur un thème bien précis. Il a été pensé pour des entreprises ou des organisations désirant suivre un ensemble d'objets OpenStreetMap en vue de leur réutilisation.`
        ),
        H3('', 'Comment ça marche'),
        P(
            '',
            `L'outil affiche dans une carte et un tableau toutes les modifications sur des objets suivis. Dans cette démo, des aménagements cyclables en Wallonie sont suivis. Toutes les heures, l'outil vérifie si des changements ont eu lieu dans OpenStreetMap sur ces objets. L'utilisateur enregistré peut en outre gérer ces données, c'est-à-dire marquer le signalement comme traité.  `
        ),
        H3('', 'Feuille de route'),
        P(
            '',
            `Notre but est de proposer un nouvel outil de suivi personnalisé de données OpenStreetMap pour tout utilisateur de données OpenStreetMap. Nous avons mis en place une feuille de route avec des fonctionnalités à développer: login et gestion des utilisateurs, notifications, analyseurs de changements intelligents, ...`
        ),
        H3('', 'Contact'),
        P(
            '',
            `OSMOA est développé par Champs Libres Coopérative & l'atelier cartographique. Vous pouvez nous contacter sur `,
            A(
                { href: 'mailto:info@champs-libres.coop' },
                'info@champs-libres.coop'
            ),
            '.'
        )
    );

const render = () => DIV('index__wrapper', H2('', 'OSMOA'), content());

export default render;
